import 'twin.macro'

import { Menu } from '@headlessui/react'
import Avatar from 'assets/icons/clarity-avatar-solid.svg?component'
import Typography from 'components/UI/Typography'
import { useAppSelector } from 'hooks'
import useLogout from 'hooks/useLogout'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { getUserRecord } from 'redux/store/slices/userSlice'
import { getUserInitials } from 'utils'

const ProfileMenu = () => {
  const { t } = useTranslation('common')
  const { first_name, middle_name, last_name } = useAppSelector(getUserRecord)

  const initials = useMemo(
    () => getUserInitials(last_name || middle_name, first_name),
    [first_name, last_name, middle_name]
  )

  const logout = useLogout()

  return (
    <Menu as='div' tw='relative'>
      <Menu.Button tw='bg-main p-2 rounded-full' className='aspect-1'>
        {!initials ? <Avatar /> : <Typography>{initials}</Typography>}
      </Menu.Button>
      <Menu.Items className='absolute right-0 w-56 p-3 mt-2 mr-2 origin-top-right bg-main rounded-md shadow-lg ring-opacity-5 focus:outline-none z-50'>
        {(first_name || middle_name || last_name) && (
          <Menu.Item>
            <div>
              <Typography weight='bold'>
                {first_name || ''} {middle_name || ''} {last_name || ''}
              </Typography>
            </div>
          </Menu.Item>
        )}
        <Menu.Item>
          {({ active }) => (
            <button
              className={`${
                active ? 'bg-selector text-primary' : 'text-secondary'
              } group flex rounded-md items-center w-full px-[12px] py-2 text-sm pl-0 mt-3`}
              onClick={logout}
            >
              {t('logout')}
            </button>
          )}
        </Menu.Item>
      </Menu.Items>
    </Menu>
  )
}
export default ProfileMenu
